// extracted by mini-css-extract-plugin
export default {"imgdiv":"_2e302d4812 _68b1d96bc7","img":"_6415666d6a _74b10eefd7"};